import type { SvgImageProps } from "@hopper-ui/components";
import type { ElementType } from "react";
import { createSvgImage } from "./createSvgImage.tsx";
import { slot } from "./utils/useSlots.tsx";

export type BrandIconSize = "sm" | "md" | "lg";

const sizeMap: Record<BrandIconSize, string> = {
    sm: "16px",
    md: "24px",
    lg: "32px"
};

export interface BrandIconProps extends Omit<SvgImageProps, "UNSAFE_width" | "UNSAFE_height" | "size"> {
    size?: BrandIconSize;
}

export function createBrandIcon(src: ElementType, displayName: string, aspectRatio = 1) {
    const SvgImage = createSvgImage(src);

    const component = ({ size = "md", ...props }: BrandIconProps) => {
        const height = Number.parseInt(sizeMap[size], 10);
        const width = Math.round(height * aspectRatio);

        return <SvgImage UNSAFE_width={`${width}px`} UNSAFE_height={`${height}px`} aria-hidden="true" {...props} />;
    };
    component.displayName = displayName;
    slot("icon", component);

    return component;
}
